// NPM Imports
import React, { Component } from "react";
import { Tooltip, Toastr } from "@revvsales/components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

// Components Imports
import NavBarItem from "./NavBarItem";
import NavBarItemOnboard from "./NavBarItemOnboard";
import NavBarItemUpgrade from "./NavBarItemUpgrade";
import { FeatureGating, OnBoardGating } from "../../../commonComponents";
import { SignOut } from "../../AuthComponents";
import NavbarShieldHelpPopup from "./NavbarShieldHelpPopup";
import NavBarInviteTeammate from "./NavBarInviteTeammate";
import ShowUserLimitIncreaseRequestPopup from "../../ShowUserLimitIncreaseRequestPopup";
import ReferralPopup from "../../SettingsWrapper/ReferralPopup";
import ShowPlanSubscribeRequestPopup from "../../ShowPlanSubscribeRequestPopup";

// Action Imports
import toggleView from "../../../actions/NavbarActions";
// import { checkInboxUnreadNotification } from "../../../actions/CommonActions/commonActions";
import { SettingsActions } from "../../../actions";

// Internal Imports
import SHIELD from "../../../assets/ic-shield.svg";
import { AmplitudeUtils, GlobalUtils } from "../../../utils";
import { BILLING, EVENTS, NAVBAR, PATHS, SETTINGS } from "../../../constants";
import {
  readDataFromLocalStorage,
  applyRbac,
} from "../../../utils/globalUtils";
import { USER_ROLES } from "../../../constants/roleList";

// service Imports
import { getUserFeaturesService } from "../../../actions/UserActions/userService";
import { getMeterUsageService } from "../../../actions/CommonActions/commonService";
import { getBillingInfo } from "../../../actions/SettingsActions/settingsService";

// Destructuring
const { NAVITEMS, GATING_TYPES } = NAVBAR;
const { BILLINGS_ENTITY_CONSUMPTION_POINT } = BILLING;
const { handleApiErrMsg } = GlobalUtils;
const { billingBandNotifyAction } = SettingsActions;

// Declarations
// let setTimeoutRef = null;

class NavBar extends Component {
  profileRef = React.createRef();

  state = {
    showProfile: false,
    showShieldHelpPopup: false,
    showTeammatePopup: false,
    rerenderNavbarComponent: false,
    userConsumptionRecord: {},
    showUserConsumptionPopup: false,
    showReferralPopup: false,
    planSubscribeRequestPopup: false,
    billingInfo: null,
  };

  componentDidMount() {
    getUserFeaturesService()
      .then(() => {
        this.setState({
          rerenderNavbarComponent: true,
        });
      })
      .catch(error => {
        const message = handleApiErrMsg(error);
        Toastr.showToastr({
          type: "failure",
          message,
          timeout: 2000,
        });
      });

    this._checkUserConsumption();
    this._getBillingInfo();
    // call the below method only for one setTimeout timer reference
    // if (!setTimeoutRef) {
    //   this._checkInboxUnseenNotifications();
    // }
    AmplitudeUtils.amplitudeLogEvent(EVENTS.EVENT_NAMES.NAV_BAR_ITEM_CLICKED);
  }

  componentDidUpdate() {
    AmplitudeUtils.amplitudeLogEvent(EVENTS.EVENT_NAMES.NAV_BAR_ITEM_CLICKED);

    // The below code(action) is responsible to trigger billing band info message
    this.props.billingBandNotifyAction(true);

    if (this.state.rerenderNavbarComponent) {
      this._stopRerender();
    }
  }

  _checkUserConsumption = () => {
    getMeterUsageService(BILLINGS_ENTITY_CONSUMPTION_POINT.USER_LICENCES)
      .then(res => {
        this.setState({ userConsumptionRecord: res });
      })
      .catch(error => {
        console.error(
          `getMeterUsageService => getMeterUsageService => Error : ${error}`,
        );
        Toastr.showToastr({
          type: "failure",
          message: "Oops! Failed to fetch user consumption record.",
          timeout: 3000,
        });
      });
  };

  _getBillingInfo = () => {
    getBillingInfo()
      .then(response => {
        this.setState({ billingInfo: response });
      })
      .catch(err => {
        console.error(`NavBar => CDM => ${err}`);
      });
  };

  _stopRerender = () => {
    this.setState({
      rerenderNavbarComponent: false,
    });
  };

  // Make an API call (every 5 Min of time interval)
  // to get the inbox unseen notifications status
  // _checkInboxUnseenNotifications = () => {
  //   this.props
  //     .checkInboxUnreadNotification()
  //     .then(() => {
  //       setTimeoutRef = setTimeout(this._checkInboxUnseenNotifications, 300000);
  //     })
  //     .catch(error => {
  //       console.error(
  //         `index.js (NavBar) => _checkInboxUnseenNotifications => ${error}`,
  //       );
  //     });
  // };

  _handleView = () => {
    AmplitudeUtils.amplitudeLogEvent(
      EVENTS.EVENT_NAMES.DOCUMENTATION_HUB_VIEWED,
    );
  };

  _toggleView = view => {
    this.props.toggleView(view);
  };

  _toggleProfile = () => {
    // attach/remove event handler
    if (!this.state.showProfile) {
      document.addEventListener(
        "click",
        this._handleShowProfileOutsideClick,
        false,
      );
    } else {
      document.removeEventListener(
        "click",
        this._handleShowProfileOutsideClick,
        false,
      );
    }
    this.setState(prevState => ({
      showProfile: !prevState.showProfile,
    }));
  };

  _handleShowProfileOutsideClick = e => {
    const node = this.profileRef.current;
    // ignore clicks on the component itself
    if (node && node.contains(e.target)) {
      return;
    }
    this._toggleProfile();
  };

  _decideNavItemsView = item => {
    switch (item.featureGating && item.featureGating.type) {
      case GATING_TYPES.FEATURE:
        return (
          <FeatureGating
            reRender={this.state.rerenderNavbarComponent}
            name={item.featureGating.featureName}
            altComponent={<NavBarItemUpgrade item={item} />}>
            <NavBarItem
              item={item}
              location={this.props.location}
              newNotification={this.props.newNotification}
            />
          </FeatureGating>
        );
      case GATING_TYPES.ON_BOARD:
        return (
          <OnBoardGating
            name={item.featureGating.name}
            altComponent={<NavBarItemOnboard item={item} />}>
            <NavBarItem
              item={item}
              location={this.props.location}
              newNotification={this.props.newNotification}
            />
          </OnBoardGating>
        );
      default:
        return (
          <NavBarItem
            item={item}
            location={this.props.location}
            newNotification={this.props.newNotification}
          />
        );
    }
  };

  _toggleNavbarPopup = (type, flag) => {
    this.setState({ [type]: flag });
  };

  _triggerPlanSubscribePopup = () => {
    this.setState({
      planSubscribeRequestPopup: true,
    });
  };

  render() {
    // READ FROM LOCAL STORAGE
    const userData = readDataFromLocalStorage("revvsalesUser");

    // LOCAL VARIABLE DECLARATIONS
    const USER_PROFILE_IMAGE_URL = userData ? userData.image_url : null;
    const NAVDATA = NAVITEMS[this.props.currentView];
    let popupSpace = null;
    if (this.state.showShieldHelpPopup) {
      popupSpace = (
        <NavbarShieldHelpPopup closePopup={this._toggleNavbarPopup} />
      );
    } else if (this.state.showTeammatePopup) {
      popupSpace = (
        <NavBarInviteTeammate closePopup={this._toggleNavbarPopup} />
      );
    } else if (this.state.showUserConsumptionPopup) {
      popupSpace = (
        <ShowUserLimitIncreaseRequestPopup
          userConsumptionRecord={this.state.userConsumptionRecord}
          onClose={this._toggleNavbarPopup}
        />
      );
    } else if (this.state.showReferralPopup) {
      popupSpace = <ReferralPopup closePopup={this._toggleNavbarPopup} />;
    } else if (this.state.planSubscribeRequestPopup) {
      popupSpace = (
        <ShowPlanSubscribeRequestPopup
          onClose={() =>
            this._toggleNavbarPopup("planSubscribeRequestPopup", false)
          }
        />
      );
    }
    return (
      <div className="navbar-wrapper">
        {popupSpace}
        {/* LOGO SECTION */}
        <section className="navbar-logo">
          <Link to={PATHS.APP_MAIN_PAGE}>
            <img
              src="https://d34fwl795uvawg.cloudfront.net/images/revv-app-logo.svg"
              className="navbar-logo-img"
              alt="Revv"
            />
          </Link>
        </section>
        {/* NAVIGATION LISTING SECTION */}
        <section>
          <ul className="navbar-list-wrapper">
            {applyRbac(
              NAVDATA.navItems,
              readDataFromLocalStorage("revvsalesUserPermissions")
                ? readDataFromLocalStorage("revvsalesUserPermissions")
                : [],
            ).map(item => (
              <li key={item.name}>{this._decideNavItemsView(item)}</li>
            ))}
          </ul>
        </section>
        {/* SETTINGS & PROFILE NAVIGATION SECTION */}
        <section className="navbar-info-wrapper">
          {/* <div>
            <Link to="#" className="navbar-view-toggle" onClick={() => this._toggleView(NAVDATA.alias)}>
              {NAVDATA.text}
            </Link>
          </div> */}
          <div className="navbar-profile-wrapper">
            <ul className="navbar-profile-info">
              {userData && userData.org_id && (
                <li className="navbar-icons">
                  <Tooltip placement="right" overlay="Refer and get benefits!">
                    <span
                      className="i-settings navbar-setting-icon"
                      onClick={() =>
                        this._toggleNavbarPopup("showReferralPopup", true)
                      }
                      onKeyPress={() => {}}
                      tabIndex="0"
                      role="button">
                      <span aria-label="referral-gift-wrapper" role="img">
                        🎁
                      </span>
                    </span>
                  </Tooltip>
                </li>
              )}

              {userData &&
                userData.roles &&
                userData.roles.length > 0 &&
                userData.roles[0].name === USER_ROLES.ADMIN && (
                  <li className="navbar-icons">
                    <Tooltip
                      placement="right"
                      overlay="Invite team members to Revv">
                      {Object.keys(this.state.userConsumptionRecord).length >
                        0 &&
                      this.state.userConsumptionRecord.limit <=
                        this.state.userConsumptionRecord.usage ? (
                        <span
                          className="navbar-setting-icon ic-invite-user"
                          onClick={() =>
                            this._toggleNavbarPopup(
                              "showUserConsumptionPopup",
                              true,
                            )
                          }
                          onKeyPress={() => {}}
                          tabIndex="0"
                          role="button">
                          <FontAwesomeIcon icon={["fal", "user-plus"]} />
                        </span>
                      ) : (
                        <span
                          className="navbar-setting-icon ic-invite-user"
                          onClick={() =>
                            this._toggleNavbarPopup("showTeammatePopup", true)
                          }
                          onKeyPress={() => {}}
                          tabIndex="0"
                          role="button">
                          <FontAwesomeIcon icon={["fal", "user-plus"]} />
                        </span>
                      )}
                    </Tooltip>
                  </li>
                )}

              <li className="navbar-icons">
                <Link
                  data-test="navbar-settings"
                  to={`/settings/${SETTINGS.SETTINGS_DEFAULT_VIEW_URL}`}>
                  <Tooltip placement="right" overlay="Settings">
                    <i className="i-settings">
                      <FontAwesomeIcon icon={["fal", "cog"]} />
                    </i>
                  </Tooltip>
                </Link>
              </li>
              {/* <li className="navbar-icons">
                  <Tooltip placement="right" overlay="Notifications">
                    <FontAwesomeIcon icon={["far", "bell"]} />
                  </Tooltip>
                </li> */}
              <li className="navbar-icons">
                <Tooltip placement="right" overlay="Revv Trust Center">
                  <span
                    className="navbar-setting-icon"
                    onClick={() =>
                      this._toggleNavbarPopup("showShieldHelpPopup", true)
                    }
                    onKeyPress={() => {}}
                    tabIndex="0"
                    role="button">
                    <img
                      src={SHIELD}
                      data-test="revvsales-trust-center"
                      className="revvsales-tc-img"
                      alt="Revv Trust Center"
                    />
                  </span>
                </Tooltip>
              </li>

              <li
                className="nav-profile-menuwrapper"
                data-test="navbar-profile-menu">
                <img
                  alt="User Profile"
                  data-test="navbar-avator"
                  className="navbar-avator"
                  onClick={this._toggleProfile}
                  onKeyPress={this._toggleProfile}
                  role="presentation"
                  src={USER_PROFILE_IMAGE_URL}
                />
                {this.state.showProfile ? (
                  <div className="nav-profile-menu" ref={this.profileRef}>
                    <ul>
                      <li>
                        <Link
                          to={`/settings/${
                            SETTINGS.SETTINGS_DEFAULT_VIEW_URL
                          }`}>
                          <div
                            className="nav-profile-menuitem"
                            data-test="navbar-open-profile">
                            <i>
                              <FontAwesomeIcon icon={["far", "user"]} />
                            </i>
                            My Profile
                          </div>
                        </Link>
                      </li>
                      <li>
                        <SignOut />
                      </li>
                    </ul>
                  </div>
                ) : null}
              </li>
              {this.state.billingInfo !== null &&
                (this.state.billingInfo.subscription.status === "in_trial" ||
                  (this.state.billingInfo.subscription.status === "active" &&
                    this.state.billingInfo.auto_downgraded === true)) && (
                  <li className="navbar-upgrade">
                    <div
                      className="navbar-upgrade-text"
                      data-test="navbar-upgrade"
                      onClick={() => this._triggerPlanSubscribePopup()}
                      onKeyPress={() => null}
                      role="button"
                      tabIndex="0">
                      Upgrade
                    </div>
                  </li>
                )}
            </ul>
          </div>
        </section>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const currentView = state.NavBarStore.appView;
  const { newNotification } = state.CommonStore;
  return { currentView, newNotification };
};

const mapDispatchToProps = {
  toggleView: view => toggleView(view),
  // checkInboxUnreadNotification,
  billingBandNotifyAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NavBar);



// WEBPACK FOOTER //
// ./src/components/NavBarWrapper/NavBar/index.js